import { PropsWithChildren } from 'react'
import styles from '@styles/components/FireflyToast.module.scss'
import cn from 'classnames'

type Props = {
  visible: boolean
}

export function FireflyToast({
  visible,
  children
}: PropsWithChildren<Props>) {
  return (
    <div
      className={cn(styles['container'], {
        [styles['container-visible']]: visible
      })}
    >
      {children}
    </div>
  )
}
